import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import UsersTab from "@/components/admin/UsersTab";
import RolesTab from "@/components/admin/RolesTab";
import MasterRateCardTab from "@/components/admin/MasterRateCardTab";

export default function AdminPage() {
  const { user } = useAuth();
  if (user && user.role !== "admin") return <Navigate to="/" replace />;

  return (
    <Layout>
      <div className="p-6 md:p-8 max-w-6xl">
        <p className="text-[10px] uppercase tracking-[0.2em] font-medium text-zinc-500 mb-1">Administration</p>
        <h1 className="font-heading text-3xl font-medium tracking-tighter mb-8">Users, Roles &amp; Rate Card</h1>
        <Tabs defaultValue="users">
          <TabsList className="bg-zinc-100 rounded-sm h-9 p-0.5 mb-6">
            <TabsTrigger value="users" data-testid="tab-admin-users" className="rounded-sm text-xs px-4 data-[state=active]:bg-white data-[state=active]:text-[#002FA7] data-[state=active]:shadow-none">Users</TabsTrigger>
            <TabsTrigger value="roles" data-testid="tab-admin-roles" className="rounded-sm text-xs px-4 data-[state=active]:bg-white data-[state=active]:text-[#002FA7] data-[state=active]:shadow-none">Roles &amp; Permissions</TabsTrigger>
            <TabsTrigger value="master-rates" data-testid="tab-admin-master-rates" className="rounded-sm text-xs px-4 data-[state=active]:bg-white data-[state=active]:text-[#002FA7] data-[state=active]:shadow-none">Master Rate Card</TabsTrigger>
          </TabsList>
          <TabsContent value="users"><UsersTab /></TabsContent>
          <TabsContent value="roles"><RolesTab /></TabsContent>
          <TabsContent value="master-rates"><MasterRateCardTab /></TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
}
